import { Component, Injector, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Mtrwd } from '../entity/Mtrwd-angular';
import { jkRestReturn, jkRestReturnClass, jkLib, entityState, quillEditorOptions, JkTableService } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ContentChange, QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { Mtrki04DetailComponent } from './mtrki04-detail.component';
import { MtrwdService } from '../_service_mtr';
import { JkSingleTableComponent, } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { MtrwdEditMobileComponent } from '../mtrwd-edit/mtrwd-edit-mobile.component';


@Component({
  selector: 'app-mtrki04',
  templateUrl: './mtrki04.component.html',
  styleUrls: [],
  providers: [],
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    QuillModule, FormsModule,
  ],
})
export class Mtrki04Component extends JkSingleTableComponent implements OnInit {
  override _programId = 'mtrki04'; //###
  constructor() {
    super();
    this.srv = new MtrwdService();
    this.masterEditPage = MtrwdEditMobileComponent;
    this.isCheckPower = false; // ###
    this.srv.programId = this.programId;
    //this.qbeConfig.addField = 'WD002,WD004,WD021'; //###
    //this.qbeConfig.addWhere = ' AND (WD015 = ' + jkLib.quotedStr(this.srv.wd015)+') '; //###
    this.gridInitOpt = { pageKind: this.pageKind, programId: this.programId, sortField: 'WD002', sort: 'desc', defaultSort: null };
    this.tableDisplayedColumns = ['WD001'];
    this.tableSrv = new JkTableService(); // ###

    this.constructorInit(); // ###
  }
  override ngOnInit() {
    super.ngOnInit();
    //this.srv.wd015 = '';
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
    this.title = '手機todo';
    //this.srv.getTodo('');
    this.wd015Change('');
  }

  override getLookup() {
    super.getLookup();

  }
  override doComReady($e: any, comName: string): void {
    super.doComReady($e, comName);
    if (comName === 'wd015') {
      this.srv.wd015 = '';
      this.wd015Change(this.srv.wd015);
    }
  }

  onTabChange($event: MatTabChangeEvent) {
    let id = this.srv.mtrWd015List[$event.index].id;
    this.wd015Change(id);
  }
  wd015Change(id: string) {
    if (false) {
      this.srv.wd015 = id;
      this.doRefresh();
      this.cdr.detectChanges();
    } else {
      this.srv.getTodo(id).subscribe((data: any) => {
        this.srv.setItemList(data.obj);
        // this.doRefresh();
        this.doUIRefresh(entityState.dsBrowse, this.srv.itemList()); // FIXME: .item 還是 .itemList() ?
        this.onAfterScroll(this.srv.item, this.jkRet);
        this.cdr.detectChanges();
      });
    }
  }
  override async titleOptionsClick(e: string) {
    //super.titleOptionsClick(e);
    if (e === 'add') {
      this.doInsertMobile();

    }
  }
  async doInsertMobile() {
    await this.showEdit(entityState.dsInsert);
  }
  async doEditMobile() {
    await this.showEdit(entityState.dsEdit);
  }
  async doQuickInsert() {
    let wd003 = await this.showInput('請輸入工作內容', 'label', '', 'textarea');
    if (wd003) {

      let item: Mtrwd = await this.srv.doInsert();
      item.WD003 = wd003;
      item.WD002 = jkLib.nowDate();
      item.WD015 = this.srv.wd015; //this.filterOpt.wd015;
      item.WD016 = this.uid;
      //this.srv.item = item;
      this.doUIPost(item);
    }
  }

  override async showEdit(state: entityState) {
    super.showEdit(state);
    /*if (state === entityState.dsInsert) {
      await this.srv.doInsert();
    };
    if (state === entityState.dsEdit) {
      this.srv.doEdit(this.srv.item); // ###
    };

    this.dialog.open(MtrwdEditMobileComponent, this.initConfig(this))
      .afterClosed().subscribe((result) => {
        if (result) {
        }
      });*/

  }
  async doFinish(itemData: Mtrwd): Promise<boolean> {
    //let bool = await super.doUIDelete(itemData);
    let bool = false;
    itemData.WD017 = 'Y';
    bool = await super.doEditAndSave(itemData);
    return bool;
  }

  //-[以上是必須的]--------------------------------------
  showDetail(item: Mtrwd) {
    this.srv.item = item;
    this.dialog
      //.open(this.masterdEditPage, this.initConfig(this)) //###
      .open(Mtrki04DetailComponent, this.initConfig(this)) //###
      .afterClosed()
      .subscribe((result) => {
        if (result) {
        }
      });
  }
  async gotoDetail(item: Mtrwd) {
    // ###
    let billList = this.getBillList('WD001').join(',');
    let captionList = this.getBillList('WD004').join(',');
    let billIndex = billList.indexOf(item.WD001);
    let param = { wl001: item.WD001, billList: billList, billIndex: billIndex, captionList: captionList };
    this.navigateTo('/mtrki04-detail', param); // { wl001: key }
  }
  getBillList(keyField: string): string[] {
    let billList = [];
    for (let i = 0; i < this.srv.itemList().length; i++) {
      const element = this.srv.itemList()[i];
      billList.push(element[keyField]);
    };
    return billList;
  }
  getBillListStr(keyField: string) {
    let billList = '';
    for (let i = 0; i < this.srv.itemList().length; i++) {
      if (i > 0) billList += ',';
      billList += this.srv.itemList()[i][keyField];
    };
    return billList;
  }
  onTabsChanged(e: any) {
    this.srv.wd015 = this.srv.mtrWd015List[e.itemIndex].id;
    this.doRefresh(); // masterSrv.doRefrewd015 = this.pageOpt.wd015;
    this.cdr.detectChanges();
  }
  wd003Text: string = '';
  quillEditorReady($event: ContentChange) {
    this.wd003Text = $event.text;
  }
  quillEditorOptions = quillEditorOptions;

  text2html(value: string): string {
    let str = jkLib.swapStr(value, '\n', '<br>');
    let s = `<h4>${str}</h4>`;
    //let s = `${str}`;
    return s;
  }
  override async doEditAndSave($event: any): Promise<boolean> {
    if (this.wd003Text === '') {
      this.wd003Text = $event.WL004;
    }
    this.wd003Text = await this.showInput('內容', '確認要存檔?', this.wd003Text, 'textarea');
    let bool = false;
    if (this.wd003Text) {
      $event.WD003 = this.wd003Text;
      bool = await super.doEditAndSave($event);
    };
    return bool;
  }

}
